module.exports = __webpack_public_path__ + "img/logo.c2fdf306.png";